import React, { useState } from "react";
import styled from "styled-components";

// components
import RollingPicker from "components/ui/popup/RollingPicker";

// utils
import { getCalendar } from "utils/date";

export const RollingDateSelect = ({
  mode,
  maxDate,
  minDate,
  onClose,
  resetDatePicker,
  onChange,
  ...props
}) => {
  const getDefaultDate = () => {
    const date = new Date(props.date || getCalendar());
    if (mode == "year" || mode == "month") date.setDate(1);
    if (mode == "year") date.setMonth(0);
    return date.getCalendar();
  };
  const [date, setDate] = useState(getDefaultDate());

  const handleChange = (type, value) => {
    const newDate = new Date(date);

    switch (type) {
      case "year":
        newDate.setFullYear(value);
        break;
      case "month":
        newDate.setMonth(value - 1);
        if (newDate.getMonth() != value - 1) {
          newDate.setMonth(value - 1);
          newDate.setDate(newDate.getEndDateInMonth().getDate());
        }
        break;
      case "day":
        newDate.setDate(value);
        break;
    }
    setDate(newDate.getCalendar());
  };

  const handleSubmit = () => {
    if (onChange) {
      onChange(date);
    }
    resetDatePicker();
  };

  const getList = (type, isRepeat = false) => {
    let min, max, suffix, value;
    switch (type) {
      case "year":
        max = maxDate ? new Date(maxDate).getFullYear() : new Date().getFullYear();
        min = minDate ? new Date(minDate).getFullYear() : max - 10;
        suffix = "년";
        value = new Date(date).getFullYear();
        break;
      case "month":
        if (mode == "year") return null;
        max = maxDate ? new Date(maxDate).getMonth() + 1 : 12;
        min = minDate ? new Date(minDate).getMonth() + 1 : 1;
        suffix = "월";
        value = new Date(date).getMonth() + 1;
        break;
      case "day":
        if (mode == "year" || mode == "month") return null;
        let currentFocusedMonth = new Date(date).getMonth() + 1;
        max = maxDate && currentFocusedMonth ===  new Date(maxDate).getMonth() + 1 ? new Date(maxDate).getDate() : new Date(date).getEndDateInMonth().getDate();
        min = minDate && currentFocusedMonth ===  new Date(minDate).getMonth() + 1 ? new Date(minDate).getDate() : 1;
        suffix = "일";
        value = new Date(date).getDate();
        break;
    }
    const options = [];
    for (let i = min; i <= max; i++) {
      options.push({ label: i + suffix, value: i });
    }
    return (
      <RollingPicker
        value={value}
        options={options}
        onChange={(value) => {
          handleChange(type, value);
        }}
        isRepeat={isRepeat}
      />
    );
  };

  return (
    <Wrapper>
      <div className="top">
        <p>날짜선택</p>
      </div>
      <div className="middle">
        {getList("year")}
        {getList("month")}
        {getList("day")}
      </div>
      <div className="bottom">
        <CustomButton onClick={handleSubmit}>확인</CustomButton>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  left: 0;
  right: 0;
  padding: 16px;
  margin-left: 20px;
  margin-right: 20px;
  height: auto;
  position: absolute;
  background-color: white;
  border: 1px solid #e1e6ed;
  border-radius: 8px;

  p {
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    color: #202020;
  }

  .middle {
    display: flex;
    margin: 0 -5px;
    justify-content: center;
    height: calc(42px * 5);
    overflow: hidden;
  }
  .middle > div {
    position: relative;
    padding: 0 5px;
    width: 100%;
    font-size: 18px;
    font-weight: 600;
  }
  .middle > div:before {
    content: "";
    position: absolute;
    left: 5px;
    top: 50%;
    right: 5px;
    height: 42px;
    background-color: #f3f6fd;
    border-radius: 8px;
    transform: translateY(-50%);
  }
  .middle li {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
  }
`;

const CustomButton = styled.button`
  width: 100%;
  outline: none;
  background-color: white;
  color: #515458;
  font-size: 16px;
  line-height: 20px;
  padding: 14px;
  border: 1px solid #e1e6ed;
  box-sizing: border-box;
  border-radius: 8px;
`;

export default RollingDateSelect;



